<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import {
		AdvancedCardV2,
		LabelV2,
		LabelListV2,
		Speedometer,
		ControlsContainer,
		Text,
	} from '@Shelly/shelly-design-system';
	//Helpers
	import { translateTemplateTitle } from 'src/helpers/xt1_helpers/template_helpers';
	//Components
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, statuses: VCInterfaceStatus[];

	$: buttonAction = statuses.find((i) => i?.hasAction);
	$: flowRate = statuses.find((i) => i?.role == 'flow_rate');
	$: labels = statuses.filter((i) => !i?.hideLabel && !i?.hasAction && i?.role != 'flow_rate');
</script>

<DeviceNotificationLabel deviceId={device?.id} />
{#each labels as status}
	{#if !status.hideLabel && !status.hasAction && status.role != 'flow_rate'}
		<AdvancedCardV2
			class="mb-s"
			title={translateTemplateTitle(status.name)}
			hideSlotMain={!status.labelList?.length}
		>
			<LabelListV2
				size="m"
				backgroundColor="--color-1"
				labelList={status.labelList || []}
				slot="main"
				data-prevent-drawer-swipe
				data-prevent-sidepanel-swipe
				a11yProps={{ isInteractive: true }}
			/>
			<LabelV2
				slot="right"
				size="l"
				value={translateTemplateTitle(status.label || status.value)}
				icon={status.icon}
			/>
		</AdvancedCardV2>
	{/if}
{/each}

<div class="flex-full-height justify-content-end neo-valve-gauge">
	{#if flowRate}
		<Speedometer
			class="mb-l mt-l"
			type="primary"
			icon={flowRate.icon}
			value={flowRate.rawValue}
			valuePrefix={flowRate.unit}
			min={flowRate.min}
			max={flowRate.max}
		/>
	{/if}
	{#if buttonAction}
		<ControlsContainer class="mt-s" color="color-0">
			<svelte:fragment slot="first">
				<VirtualBooleanButton
					isWide
					{device}
					componentID={buttonAction.id}
					value={buttonAction.event}
					icon={buttonAction.icon}
					useV2Components
				/>
				<Text styleType="controls-large" class="mt-s-plus text-bold"
					>{buttonAction.event
						? $format('option_command_close', { default: 'Close' })
						: $format('option_command_open', { default: 'Open' })}</Text
				>
			</svelte:fragment>
		</ControlsContainer>
	{/if}
</div>

<style>
	:global(.neo-valve-gauge .speedometer-text-styles) {
		font-size: 26px;
	}
</style>
